module.exports = __webpack_public_path__ + "img/sample-report-bcg-box.950014e.webp";